// src/index.tsx
import './styles/index.css'; // Import Tailwind styles
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./index.css";
import './i18n';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import { environment } from './config/environment';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

// if (environment.enable) {
serviceWorkerRegistration.register();
// }else{
  
  // serviceWorkerRegistration.unregister();
// }


